import { render, staticRenderFns } from "./image_static.vue?vue&type=template&id=2ebe087c"
import script from "./image_static.vue?vue&type=script&lang=js"
export * from "./image_static.vue?vue&type=script&lang=js"
import style0 from "./image_static.vue?vue&type=style&index=0&id=2ebe087c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports